import React from 'react'
import ButtonMinimalist from '../../general/button/ButtonMinimalist'
import { useNavigate } from 'react-router-dom'
import './style.css'

export default function MMenu({text, title, image, imageAlt, textButton, linkButton}) {
  let navigate = useNavigate()  

  return (
    <div className="m_menu" >
        <img src={image} alt={imageAlt} />
        <div>
            <h2 className='title'>{title}</h2>
            <p className='text'>{text}</p>
        </div>
        <ButtonMinimalist text={textButton} onClick={() => navigate(linkButton)} />
    </div>
  )
}
